import gql from 'graphql-tag'

import { ForgotPasswordMutation } from '../../../types/api'

export default {
  mutation: gql`
    mutation forgotPassword($email: String!) {
      rdvForgotPassword(email: $email)
    }
  `,
  transformer: (response: ForgotPasswordMutation) => {
    return response
  },
}
